export default __webpack_public_path__ + "static/media/lm_vc_1.795a5f64.png";